import { Link } from '@compat/router';
import LoadingSkeleton from '@components/LoadingSkeleton';
import { bgNewsNoImage } from '@images';
import type { NewsItemT } from '@queries/news';

interface NewsListCardProps {
  item: NewsItemT;
}

export const NewsListCard = ({ item }: NewsListCardProps) => {
  const { id, title, annotation, attachmentsItem } = item;

  return (
    <li className='news-list-card'>
      <Link to={`/news/${id}`}>
        <div
          className='bg-image'
          style={{
            backgroundImage: `url(${
              attachmentsItem ? attachmentsItem.tempFullFilePath : bgNewsNoImage
            })`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
            width: '454px',
            height: '454px'
          }}
        />

        <div className='news-title'>
          {title && (
            <div className='title'>
              <p dangerouslySetInnerHTML={{ __html: title }} />
            </div>
          )}
          {annotation && (
            <div className='info'>
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    annotation.length >= 155
                      ? `${annotation.substr(3, 135)} ... `
                      : `${annotation} `
                }}
              />
              <span className='more'>подробнее</span>
            </div>
          )}
        </div>
      </Link>
    </li>
  );
};

export const NewsListCardLoading = () => (
  <li className='news-list-card'>
    {/* bg-image — чтобы скелетон получал те же адаптивные размеры из scss */}
    <LoadingSkeleton
      className='bg-image'
      style={{ width: '454px', height: '454px', display: 'block' }}
    />
    <div className='news-title'>
      <div className='title'>
        <LoadingSkeleton className='h-[1lh] w-3/4' />
      </div>
      <div className='info'>
        <LoadingSkeleton className='h-[1lh] w-full' />
        <LoadingSkeleton className='h-[1lh] w-2/3' />
      </div>
    </div>
  </li>
);
